import { useHistory } from 'react-router-dom';

import { routes } from 'app/routes';
import { ErrorCode, Messages } from 'pkg/Alerts/Messages';
import { useContext } from 'react';
import { UserContext } from '../Context';

interface RedirectData extends Messages {
  id: string;
  email: string;
}

export const useRedirectToUpdater = (route: string) => {
  const history = useHistory();
  const { setUser } = useContext(UserContext);

  return ({ id, messages, email }: RedirectData) => {
    setUser({email, name: ''}) 
    if (messages?.some(({ errorCode }) => errorCode === ErrorCode.TURBO_QUOTE_NOT_POSSIBLE)) {
      return history.push(`${routes.AUTOMATED_QUOTE_GENERATION}/${id}`);
    }
    return history.push(`${route}${routes.THANK_YOU}/${id}`);
  };
};
